import { RequestErrorDataApi } from "../errors"
import { dataAPI } from "./api"
import { DataApiQueryOptions, Receiver } from "./models/api/api"
import { SuggestionsResponse } from "./models/suggestions"

export const getAutoCompleteSuggestions = async (
    itemId: number,
    fieldDefinitionId: string,
    searchText: string,
    queryParameters?: DataApiQueryOptions,
    receiver?: Receiver,
    defaultErrorMessage?: string,
): Promise<string[]> => {
    try {
        return (
            await dataAPI.getJSON<SuggestionsResponse>(
                `ItemFields(itemId=${itemId},fieldDefinitionId='${fieldDefinitionId}')/TF.TextItemField/GetSuggestions(searchText='${searchText}')`,
                queryParameters,
                receiver,
            )
        ).value
    } catch (error) {
        if (error instanceof Response) {
            const errorMessage =
                error instanceof Error
                    ? error.message
                    : defaultErrorMessage || ""
            throw await RequestErrorDataApi.create(
                errorMessage,
                error.status,
                error,
            )
        }
        throw error
    }
}
